/* eslint-disable no-empty-pattern */
const defaultExportDetails = {
  fileType: 'Excel',
  fileName: '',
  fileFormat: 'xlsb',
  fileSheetName: 'Guest List',
  fileSheetColumnOrder: ['firstName', 'lastName'],
  guestSelection: 'all',
  exportQRCodeData: false,
};

export default {
  namespaced: true,
  state: {
    dialogIsVisible: false,
    exportDetails: defaultExportDetails,
  },
  mutations: {
    RESET_GUEST_EXPORT_STATE(state) {
      state.dialogIsVisible = false;
      state.exportDetails = { ...defaultExportDetails };
    },
    SET_DIALOG_IS_VISIBLE(state, dialogIsVisible) {
      state.dialogIsVisible = dialogIsVisible;
    },
    SET_EXPORT_DETAILS(state, exportDetails) {
      state.exportDetails = exportDetails;
    },
  },
  actions: {
    resetGuestExportState: ({ commit }) => {
      commit('RESET_GUEST_EXPORT_STATE');
    },
    updateDialogIsVisible: ({ commit }, dialogIsVisible) => {
      commit('SET_DIALOG_IS_VISIBLE', dialogIsVisible);
    },
    updateExportDetails: ({ commit }, exportDetails) => {
      commit('SET_EXPORT_DETAILS', exportDetails);
    },
  },
};
